module.exports = __webpack_public_path__ + "fi-msc-021f087a6d2716dacbf521cd533171cf.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/fi-msc.png
// module id = 84
// module chunks = 0